import { defineComponent, ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/less';
import SwiperHeader from '@/components/SwiperHeader.vue';
import SwiperContestList from './SwiperContestList.vue';
import SwiperActivitySlide from './SwiperActivitySlide.vue';
import { HomeService } from '@/services/home.service';
import { useService } from '@kaokei/use-vue-service';
export default defineComponent({
  name: 'SwiperActivityArea',
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide,
    SwiperHeader: SwiperHeader,
    SwiperContestList: SwiperContestList,
    SwiperActivitySlide: SwiperActivitySlide
  },
  setup: function setup() {
    var homeService = useService(HomeService);
    homeService.getNavBarList();
    var swiperRef = ref();
    var swiperHeaderRef = ref();

    var onChangeHeader = function onChangeHeader(index) {
      if (swiperRef.value) {
        swiperRef.value.slideTo(index);
      }
    };

    var onInitSwiper = function onInitSwiper(s) {
      swiperRef.value = s;
    };

    var onSlideChange = function onSlideChange(s) {
      if (swiperHeaderRef.value) {
        swiperHeaderRef.value.slideTo(s.activeIndex);
      }
    };

    return {
      homeService: homeService,
      swiperHeaderRef: swiperHeaderRef,
      onChangeHeader: onChangeHeader,
      onInitSwiper: onInitSwiper,
      onSlideChange: onSlideChange
    };
  }
});